<form [formGroup]="tenderForm">
  <div class="form-inputs form-dropdown" *ngIf="purchaseType != 'dc'">
    <p class="paragraph-medium-regular">Target schedule date <span class="required">*</span></p>
    
    <mat-form-field>
      <mat-label>dd / mm / yyyy</mat-label>
      <input
        matInput
        formControlName="TargetScheduleDate"
        [matDatepicker]="pickerTargetScheduleDate"
        id="plannedDDPicker"
        [min]="minDate"
        [readonly]="isReadOnly"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="pickerTargetScheduleDate"
        [disabled]="isReadOnly"
      ></mat-datepicker-toggle>
      <mat-datepicker #pickerTargetScheduleDate></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="form-inputs form-dropdown">
    <p class="paragraph-medium-regular">Delivery address <span class="required">*</span></p>
    <ng-select
      [items]="deliveryAddressDropdown"
      appearance="outline"
      bindLabel="value"
      formControlName="DeliveryAddress"
      [readonly]="isReadOnly"
      dropdownPosition="top"
    >
    </ng-select>
  </div>
  <div
    class="form-inputs form-padding"
    *ngIf="tenderItem?.DeliveryAddress?.id === 'others'"
  >
    <input
      class="tender-input"
      formControlName="PleaseSpecify"
      [readonly]="isReadOnly"
      placeholder="Please specify"
    />
  </div>
</form>
